import { render } from "./suplierType.vue?vue&type=template&id=88d8ac76&scoped=true"
import script from "./suplierType.vue?vue&type=script&lang=js"
export * from "./suplierType.vue?vue&type=script&lang=js"

import "./suplierType.vue?vue&type=style&index=0&id=88d8ac76&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88d8ac76"]])

export default __exports__